import actionTypePrefixes from "../../actions/actionTypePrefixes"

const initialState = {
  isLoading: true,
  loadingFailed: false,
  widgets: {
    reviewAgreement: { data: null, subtitle: null },
    temperatureCheckScores: { data: null, subtitle: null },
    topUsedFeatures: { data: null, subtitle: null },
    temperatureCheckResponseRate: { data: null, subtitle: null },
    coffeeChatsCompleted: { data: null, subtitle: null },
    numberOfLogins: { data: null, subtitle: null },
    reviewsCompleted: { data: null, subtitle: null },
  },
}

export default function activityAndGeneralStatsReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.ActivityAndGeneralStats) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.ActivityAndGeneralStats, "")

  switch (actionType) {
    case "LOAD_DASHBOARD_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: true,
        loadingFailed: false,
        widgets: {
          reviewAgreement: { data: null, subtitle: null },
          temperatureCheckScores: { data: null, subtitle: null },
          topUsedFeatures: { data: null, subtitle: null },
          temperatureCheckResponseRate: { data: null, subtitle: null },
          coffeeChatsCompleted: { data: null, subtitle: null },
          numberOfLogins: { data: null, subtitle: null },
          reviewsCompleted: { data: null, subtitle: null },
        },
      }

    case "LOAD_DASHBOARD_DATA_SUCCESS":
      // Mocked below...waiting for real data to come in via `action.payload.data`

      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        widgets: {
          ...state.widgets,
          reviewAgreement: action.payload.data.reviewAgreement,
          temperatureCheckScores: action.payload.data.temperatureCheckScores,
          numberOfLogins: action.payload.data.numberOfLogins,
          topUsedFeatures: action.payload.data.featureUsage,
          temperatureCheckResponseRate: action.payload.data.temperatureCheckResponseRate,
          coffeeChatsCompleted: action.payload.data.coffeeChatsCompleted,
          reviewsCompleted: action.payload.data.reviewCompletion,
        },
      }

    case "LOAD_DASHBOARD_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
        isLoading: false,
        loadingFailed: true,
        widgets: {
          ...state.widgets,
          reviewAgreement: { data: null, subtitle: null },
          temperatureCheckScores: { data: null, subtitle: null },
          topUsedFeatures: { data: null, subtitle: null },
          numberOfLogins: { data: null, subtitle: null },
          temperatureCheckResponseRate: { data: null, subtitle: null },
          coffeeChatsCompleted: { data: null, subtitle: null },
          reviewsCompleted: { data: null, subtitle: null },
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/activityAndGeneralStatsReducer.js